import { useState } from "react";
import { MdPeopleOutline } from "react-icons/md";
import Modal from "../../../../components/modals/Modal";
import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import { useTournament } from "../../TournamentContext";
import { FaCheckCircle } from "react-icons/fa";
import PlayerSearch from "../../../../components/PlayerSearch";
import { SUCCESS_DELAY } from "../../../../constants";

const AddOrganizer = () => {
  const { tournamentId } = useTournament();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfileUuid, setSelectedProfileUuid] = useState(undefined);
  const [success, setSucces] = useState(undefined);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleProfileSelect = (value, index) => {
    setSelectedProfileUuid(value);
  };

  const writeNewOrganizer = async () => {
    if (!selectedProfileUuid) {
      return alert("Please select a profile");
    }

    const tournamentRef = doc(firestore, "tournaments", tournamentId);

    try {
      await updateDoc(tournamentRef, {
        organizerUids: arrayUnion(selectedProfileUuid),
      });
      setSucces(true);
      setSelectedProfileUuid(undefined);
      setTimeout(() => setSucces(undefined), SUCCESS_DELAY);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="w-full mb-2">
      <MdPeopleOutline
        className="h-9 w-9 text-stone-600 cursor-pointer"
        onClick={() => toggleModal()}
      />

      <Modal
        isOpen={isModalOpen}
        title="Add Organizer"
        subtitle="Better with friends"
        onCancel={toggleModal}
        onConfirm={writeNewOrganizer}
      >
        <div className="h-36">
          <div className="text-sm text-stone-600 ml-1">
            Make sure they've filled out their profile!
          </div>
          <PlayerSearch
            index={0}
            playerName={""}
            onChange={() => {}}
            onSelect={handleProfileSelect}
          />
          {success && (
            <div className="w-32 flex items-center p-2 bg-green-100 border border-green-400 text-green-800 rounded-2xl shadow-md">
              <FaCheckCircle className="w-6 h-6 mr-2 text-green-600" />
              <span>Success</span>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default AddOrganizer;
